// extracted by mini-css-extract-plugin
export default {"modalWindow":"SelectDocumentModalWindow_modalWindow__lOvJ1"};